import { Button, Row, Typography } from "antd";
import { PaymentButton } from "../../payment-button/payment-button.component";
import { WhatsAppOutlined } from "@ant-design/icons";
import Lock from "../../../assets/images/lock.png";
import { useSelector } from "react-redux";
import {
  selectDeadline,
  selectNotificationOpenAndReferred,
  selectNotificationText,
} from "../../../store/timer/timer.selector";
import { StyledCountdown } from "../notification/notification.styles";
import { contactUs } from "../../../utils/utils";
import {
  setDeadline,
  setModalOpen,
  setNotificationOpen,
} from "../../../store/timer/timer.reducer";
import { useAppDispatch } from "../../../store/store";
import { LogoutButton } from "../../logout-button/logout-button.component";
import { useGetSummariesQuery } from "../../../store/api/api";
import { selectIsFreeTier } from "../../../store/selectors/global.selector";

export const PendingAction = () => {
  const dispatch = useAppDispatch();

  const notificationOpenAndReferred = useSelector(
    selectNotificationOpenAndReferred
  );
  const notificationText = useSelector(selectNotificationText);
  const deadline = useSelector(selectDeadline);

  const onClickToContinue = () => {
    dispatch(setModalOpen(true));
  };

  const onFinish = () => {
    dispatch(setDeadline(0));
    dispatch(setNotificationOpen(false));
  };

  const { isFreeTier } = useGetSummariesQuery(undefined, {
    selectFromResult: ({ data }) => selectIsFreeTier(data || []),
  });

  return (
    <>
      <Row justify="center">
        <img src={Lock} height="40px" alt="lock" />
      </Row>
      <Row
        justify="center"
        style={{
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <div style={{ textAlign: "center", width: "100%" }}>
          <strong style={{ fontSize: "1.5rem", lineHeight: "2rem" }}>
            Welcome to Web Dashboard
          </strong>
        </div>
        <div>
          {notificationOpenAndReferred ? (
            <strong style={{ color: "#ff4d4f", textAlign: "center" }}>
              {notificationText}
              <StyledCountdown
                color="#ff4d4f"
                format="mm:ss"
                suffix="left"
                value={deadline}
                onFinish={onFinish}
              />
            </strong>
          ) : (
            <strong
              style={{
                color: "grey",
                fontSize: "1rem",
                lineHeight: "1.5rem",
              }}
            >{`To unlock and start using web dashboard, please buy a new number`}</strong>
          )}
        </div>
      </Row>
      <Row
        justify="space-between"
        style={{ margin: "1rem 0", padding: "0 2.5rem" }}
      >
        {notificationOpenAndReferred ? (
          <Button danger type="primary" onClick={onClickToContinue}>
            Click to Continue
          </Button>
        ) : isFreeTier ? (
          <Button
            type="primary"
            onClick={() =>
              contactUs("I would like to upgrade from my free tier plan")
            }
          >
            Upgrade
          </Button>
        ) : (
          <PaymentButton paymentText="Buy a new Number !" />
        )}
        <LogoutButton>Logout</LogoutButton>
      </Row>
      <Row justify="center">
        <iframe
          width="676"
          height="380"
          src="https://www.youtube.com/embed/1Qtqvzcblyg"
          title="Superfone — Web Dashboard Tutorial"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </Row>
      <Row
        justify="center"
        align="middle"
        style={{ padding: "0.5rem 0 0 0", fontSize: "1rem", gap: "0.5rem" }}
      >
        <WhatsAppOutlined />
        <Typography.Text>
          Need help?{" "}
          <strong
            onClick={() => {
              contactUs("I need help");
            }}
            style={{
              textDecoration: "underline",
              textAlign: "center",
              cursor: "pointer",
              color: "blue",
            }}
          >
            Chat with live agent
          </strong>
        </Typography.Text>
      </Row>
    </>
  );
};
